module.exports = __webpack_public_path__ + "/images/cover-regalos-party.b5a45aa.svg";